export default __webpack_public_path__ + "static/media/important-message.5bd46e36.svg";